import type {Healthcare} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useHealthcare() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'healthcareGlobal',
      depth: 3,
      draft: !!route.query.preview,
    })

    return result as Populated<Healthcare>
  }

  return {fetch}
}
